export const INVESTIGATIONS = 'Lab Investigations';
export const INVESTIGATION = 'Lab Investigation';
export const MEDICINES = 'Medications';
export const DIAGNOSIS = 'Diagnosis';
export const SYMPTOMS = 'Symptoms';
export const LAB_VITALS = 'Lab Vitals';
export const EXAMINATIONS = 'Examination Findings';
export const DENTAL_EXAMINATIONS = 'Dental Examinations / Past Procedures';
export const DENTAL_PROCEDURES = 'Dental Procedures';
export const INJECTIONS = 'Injections';
export const PROCEDURES = 'Procedures';
